import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import OkIcon from 'assets/svg/ok';
const action = (
<div className="addSaved">
      <OkIcon/>
      Campagne Sauvé
      <CloseIcon />
      </div>
  );

const Toast = ({ handleClose,open}) => {
    const right="right"
    const vertical="top"
  return (
    <>
    {/* <div className="addSaved"> */}
    <Snackbar className="addSaved"  action={action}
    
    style={{position: "absolute",
        top: "0",
        left: "inherit",
        right: "0",
        bottom: "inherit",}}
        // anchorOrigin={{vertical, right}}
        open={open}
        onClose={handleClose}
        icon={<OkIcon/>}
        message=""
      /> 
{/* </div> */}
</>
  )
}

export default Toast